import { forwardRef, type Ref, type SVGProps } from "react";
const IconBikeOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M24.5 15a5.4 5.4 0 0 0-1.52.22l-1-1.86V9h2a1 1 0 0 0 0-2H19a1 1 0 0 0 0 2h1v3h-8v-2h1a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2h1v3.36l-1 1.86A5.4 5.4 0 0 0 7.5 15a5.5 5.5 0 1 0 5.5 6h2.1a1 1 0 0 0 .89-.53L19 14h1l1.16 2.14A5.49 5.49 0 1 0 24.5 15m-17 9a3.5 3.5 0 0 1 0-7 3.6 3.6 0 0 1 .56.06l-1.35 2.56a.91.91 0 0 0 0 .93 1 1 0 0 0 .89.45H11a3.51 3.51 0 0 1-3.5 3m3.15-5H9l.71-1.19a3.8 3.8 0 0 1 .94 1.19m3.85 0h-1.71a5.53 5.53 0 0 0-2-2.92L12 14h5Zm10 5a3.49 3.49 0 0 1-2.37-6.06l1.38 2.53a1 1 0 0 0 .89.53 1 1 0 0 0 .45-.1.93.93 0 0 0 .44-1.28l-1.35-2.56A3.49 3.49 0 1 1 24.5 24" />
  </svg>
);
const ForwardRef = forwardRef(IconBikeOutlineSVG);
ForwardRef.displayName = "IconBikeOutline";
export { ForwardRef as IconBikeOutline };
